import { productAddedToCartMessageStyles as styles } from "@insite/content-library/Components/ProductAddedToCartMessage";
import { css } from "styled-components";

styles.defaultText = {
    css: css`
        margin-bottom: 0;
    `,
};
